"use strict";
window.up.compiler('.js-post_like', function (element) {
    if (element instanceof HTMLElement) {
        // The .js-post_like button is outside the form on purpose,
        // to prevent it from being removed from the DOM when liking and unliking.
        //
        // This is necessary for accessibility
        // (SR reading context has to stay on the button so it can't be removed/replaced in the DOM)
        // and to prevent flickering of CSS styles
        window.up.on(element, 'click', undefined, function () {
            // there can be more than one form matching
            const form = document.querySelector(`${element.dataset.formSelector}`);
            form && window.up.submit(form);
        });
    }
});
window.up.compiler('.js-post_like_form', function (element) {
    if (element instanceof HTMLElement) {
        // titles must be set via JS when the form loads
        // because we cannot replace the whole button (see previous comment)
        const buttons = Array.from(document.querySelectorAll('.js-post_like'));
        buttons.forEach(button => {
            const srTitle = button === null || button === void 0 ? void 0 : button.querySelector('.js-sr_title');
            if (button && srTitle) {
                if (element.dataset.liked) {
                    button.title = element.dataset.titleLiked || '';
                    srTitle.textContent = ', ' + element.dataset.titleLiked;
                }
                else {
                    button.title = element.dataset.titleNotLiked || '';
                    srTitle.textContent = ', ' + element.dataset.titleNotLiked;
                }
            }
        });
    }
});
